import { gql } from '@apollo/client';

export const terminateClubVendorMutation = gql`
  mutation TerminateClubVendor($input: TerminateClubVendorInput!) {
    terminateClubVendor(input: $input) {
      vendorId
    }
  }
`;
